export default [
    {
        "code": "R10",
        "nom": "Tétrachlorométhane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": 1.1,
        "inflammable": false
    },
    {
        "code": "R11",
        "nom": "Trichlorofluorométhane",
        "type": "CFC",
        "prg": 4750,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R12",
        "nom": "Dichlorodifluorométhane",
        "type": "CFC",
        "prg": 8100,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R13",
        "nom": "Chlorotrifluorométhane",
        "type": "CFC",
        "prg": 14000,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R14",
        "nom": "Tétrafluorométhane",
        "type": "PFC",
        "prg": 6500,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R21",
        "nom": "Dichlorofluorométhane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.04,
        "inflammable": false
    },
    {
        "code": "R22",
        "nom": "Chlorodifluorométhane",
        "type": "HCFC",
        "prg": 1500,
        "odp": 0.055,
        "inflammable": false
    },
    {
        "code": "R23",
        "nom": "Trifluorométhane",
        "type": "HFC",
        "prg": 14800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R30",
        "nom": "Dichlorométhane",
        "type": "Chloroalcane",
        "prg": 9,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R31",
        "nom": "Chlorofluorométhane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.02,
        "inflammable": false
    },
    {
        "code": "R32",
        "nom": "Difluorométhane",
        "type": "HFC",
        "prg": 650,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R40",
        "nom": "Chlorométhane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R41",
        "nom": "Fluorométhane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R50",
        "nom": "Méthane",
        "type": "Alcane",
        "prg": 21,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R110",
        "nom": "Hexachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R111",
        "nom": "Pentachlorofluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R112",
        "nom": "1,1,2,2-Tétrachloro-1,2-difluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R112a",
        "nom": "1,1,1,2-Tétrachloro-2,2-difluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R113",
        "nom": "1,1,2-Trichloro-1,2,2-trifluoroéthane",
        "type": "CFC",
        "prg": 4800,
        "odp": 0.8,
        "inflammable": false
    },
    {
        "code": "R113a",
        "nom": "1,1,1-Trichloro-2,2,2-trifluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R114",
        "nom": "1,2-Dichloro-1,1,2,2-tétrafluoroéthane",
        "type": "CFC",
        "prg": 9800,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R114a",
        "nom": "1,1-Dichloro-1,2,2,2-tétrafluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R115",
        "nom": "Chloropentafluoroéthane",
        "type": "CFC",
        "prg": 7200,
        "odp": 0.6,
        "inflammable": false
    },
    {
        "code": "R116",
        "nom": "Hexafluoroéthane",
        "type": "PFC",
        "prg": 9200,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R120",
        "nom": "Pentachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R121",
        "nom": "1,1,2,2-Tétrachloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R121a",
        "nom": "1,1,1,2-Tétrachloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122",
        "nom": "1,1,2-Trichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122a",
        "nom": "1,1,2-Trichloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122b",
        "nom": "1,1,1-Trichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R123",
        "nom": "2,2-dichloro-1,1,1-trifluoroéthane",
        "type": "HCFC",
        "prg": 90,
        "odp": 0.02,
        "inflammable": false
    },
    {
        "code": "R123a",
        "nom": "1,2-Dichloro-1,1,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R123b",
        "nom": "1,1-Dichloro-1,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R124",
        "nom": "1-Chloro-1,2,2,2-tétrafluoroéthane",
        "type": "HCFC",
        "prg": 470,
        "odp": 0.022,
        "inflammable": false
    },
    {
        "code": "R124a",
        "nom": "1-Chloro-1,1,2,2-tétrafluoroéthane",
        "type": "HCFC",
        "prg": 620,
        "odp": 0.022,
        "inflammable": false
    },
    {
        "code": "R125",
        "nom": "Pentafluoroéthane",
        "type": "HFC",
        "prg": 2800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE125",
        "nom": "Difluorométhoxytrifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R130",
        "nom": "1,1,2,2-Tétrachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R130a",
        "nom": "1,1,1,2-Tétrachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131",
        "nom": "1,1,2-Trichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131a",
        "nom": "1,1,2-Trichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131b",
        "nom": "1,1,1-Trichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132",
        "nom": "Dichlorodifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132a",
        "nom": "1,1-Dichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132b",
        "nom": "1,2-Dichloro-1,1-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132c",
        "nom": "1,1-Dichloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R133",
        "nom": "1-Chloro-1,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R133a",
        "nom": "1-Chloro-2,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.06,
        "inflammable": false
    },
    {
        "code": "R133b",
        "nom": "1-Chloro-1,1,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R134",
        "nom": "1,1,2,2-Tétrafluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R134a",
        "nom": "1,1,1,2-Tétrafluoroéthane",
        "type": "HFC",
        "prg": 1300,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE134",
        "nom": "Difluorométhoxydifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R140",
        "nom": "1,1,2-trichloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R140a",
        "nom": "1,1,1-trichloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": 0.1,
        "inflammable": false
    },
    {
        "code": "R141",
        "nom": "1,2-dichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R141a",
        "nom": "1,1-dichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R141b",
        "nom": "1,1-dichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": 600,
        "odp": 0.11,
        "inflammable": false
    },
    {
        "code": "R142a",
        "nom": "1-chloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R142b",
        "nom": "1-chloro-1,1-difluoroéthane",
        "type": "HCFC",
        "prg": 1800,
        "odp": 0.065,
        "inflammable": false
    },
    {
        "code": "R143",
        "nom": "1,1,2-trifluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R143a",
        "nom": "1,1,1-trifluoroéthane",
        "type": "HFC",
        "prg": 3800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R143m",
        "nom": "Méthoxytrifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "RE143a",
        "nom": "Méthoxy-2,2,2-trifluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R151",
        "nom": "Chlorofluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R151a",
        "nom": "1-chloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R152",
        "nom": "1,2-difluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R152a",
        "nom": "1,1-difluoroéthane",
        "type": "HFC",
        "prg": 140,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R161",
        "nom": "Fluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R170",
        "nom": "Éthane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R211",
        "nom": "1,1,1,2,2,3,3-heptachloro-3-fluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R212",
        "nom": "Hexachlorodifluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R213",
        "nom": "1,1,1,3,3-pentachloro-2,2,3-trifluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R214",
        "nom": "1,2,2,3-tétrachloro-1,1,3,3-tétrafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R215",
        "nom": "1,1,1-trichloro-2,2,3,3,3-pentafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R216",
        "nom": "1,2-dichloro-1,1,2,3,3,3-hexafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R216ca",
        "nom": "1,3-dichloro-1,1,2,2,3,3-hexafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R217",
        "nom": "1-chloro-1,1,2,2,3,3,3-heptafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R217ba",
        "nom": "2-chloro-1,1,1,2,3,3,3-heptafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R218",
        "nom": "Octafluoropropane",
        "type": "PFC",
        "prg": 7000,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R221",
        "nom": "1,1,1,2,2,3-hexachloro-3-fluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R222",
        "nom": "Pentachlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R222c",
        "nom": "1,1,1,3,3-pentachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223",
        "nom": "Téetrachlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223ca",
        "nom": "1,1,3,3-tétrachloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223cb",
        "nom": "1,1,1,3-tétrachloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224",
        "nom": "Trichlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224ca",
        "nom": "1,3,3-trichloro-1,1,2,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224cb",
        "nom": "1,1,3-trichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224cc",
        "nom": "1,1,1-trichloro-2,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225",
        "nom": "dichloropentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225aa",
        "nom": "2,2-dichloro-1,1,1,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ba",
        "nom": "2,3-dichloro-1,1,1,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225bb",
        "nom": "1,2-dichloro-1,1,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ca",
        "nom": "3,3-dichloro-1,1,1,2,2-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225cb",
        "nom": "1,3-dichloro-1,1,2,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": 0.07,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225cc",
        "nom": "1,1-dichloro-1,2,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225da",
        "nom": "1,2-dichloro-1,1,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ea",
        "nom": "1,3-dichloro-1,1,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225eb",
        "nom": "1,1-dichloro-1,2,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226",
        "nom": "Chlorohexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ba",
        "nom": "2-chloro-1,1,1,2,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ca",
        "nom": "3-chloro-1,1,1,2,2,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226cb",
        "nom": "1-chloro-1,1,2,2,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226da",
        "nom": "2-chloro-1,1,1,3,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ea",
        "nom": "1-chloro-1,1,2,3,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ca",
        "nom": "1,1,2,2,3,3,3-heptafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ca2",
        "nom": "Trifluorométhoxy-1,1,2,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ea",
        "nom": "1,1,1,2,3,3,3-heptafluoropropane",
        "type": "HFC",
        "prg": 2900,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R227me",
        "nom": "Trifluorométhoxy-1,2,2,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R231",
        "nom": "Pentachlorofluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232",
        "nom": "Tétrachlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232ca",
        "nom": "1,1,3,3-tétrachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232cb",
        "nom": "1,1,1,3-tétrachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233",
        "nom": "Trichlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233ca",
        "nom": "1,1,3-trichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233cb",
        "nom": "1,1,3-trichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233cc",
        "nom": "1,1,1-trichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234",
        "nom": "Dichlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234aa",
        "nom": "2,2-dichloro-1,1,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ab",
        "nom": "2,2-dichloro-1,1,1,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ba",
        "nom": "1,2-dichloro-1,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234bb",
        "nom": "2,3-dichloro-1,1,1,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234bc",
        "nom": "1,2-dichloro-1,1,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ca",
        "nom": "1,3-dichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cb",
        "nom": "1,1-dichloro-2,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cc",
        "nom": "1,3-dichloro-1,1,2,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cd",
        "nom": "1,1-dichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234da",
        "nom": "2,3-dichloro-1,1,1,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234fa",
        "nom": "1,3-dichloro-1,1,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234fb",
        "nom": "1,1-dichloro-1,3,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235",
        "nom": "Chloropentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235ca",
        "nom": "1-chloro-1,2,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235cb",
        "nom": "3-chloro-1,1,1,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235cc",
        "nom": "1-chloro-1,1,2,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235da",
        "nom": "2-chloro-1,1,1,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235fa",
        "nom": "1-chloro-1,1,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236cb",
        "nom": "1,1,1,2,2,3-hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236ea",
        "nom": "1,1,1,2,3,3-hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236fa",
        "nom": "1,1,1,3,3,3-Hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236me",
        "nom": "2-(difluorométhoxy)-1,1,1,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "RFE-36",
        "nom": "Hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R241",
        "nom": "Tétrachlorofluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R242",
        "nom": "Trichlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243",
        "nom": "Dichlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ca",
        "nom": "1,3-dichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243cb",
        "nom": "1,1-dichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243cc",
        "nom": "1,1-dichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243da",
        "nom": "2,3-dichloro-1,1,1-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ea",
        "nom": "1,3-dichloro-1,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ec",
        "nom": "1,3-dichloro-1,1,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R244",
        "nom": "Chlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R290",
        "nom": "Propane",
        "type": "Alcane",
        "prg": 3.3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R600a",
        "nom": "2-Méthylpropane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1130",
        "nom": "1,2-dichloroéthylène",
        "type": "Chloroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1132",
        "nom": "1,1-Difluoroéthylène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1140",
        "nom": "Chlorure de vinyle",
        "type": "Chloroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1141",
        "nom": "Fluoroéthylène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1150",
        "nom": "Éthylène",
        "type": "Alcène",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1216",
        "nom": "Hexafluoropropène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1218",
        "nom": "Hexafluoropropène (trimère)",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1234ze",
        "nom": "Tétrafluoropropène",
        "type": "HFC",
        "prg": 6,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1270",
        "nom": "Propylène",
        "type": "Alcène",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R410A",
        "nom": "R410A",
        "type": "HFC (mélange R32 / R125)",
        "prg": 2088,
        "odp": 0,
        "inflammable": false
    }
]